import { store } from './storage';

const KEY = 'navi.disclaimer.v1';

/**
 * 起動時の同意モーダル。
 * 同意ボタンのタップを「最初のユーザー操作」として使い、音声・スリープ防止・方位の許可をまとめて取る。
 * （iOS はこれらをユーザー操作のハンドラ内でしか許可しない）
 */
export function showDisclaimer(onAccept: () => void | Promise<void>): void {
  const agreed = store.get(KEY) === '1';
  const el = document.createElement('div');
  el.className = 'modal-backdrop';
  el.innerHTML = `
    <div class="modal" role="dialog" aria-modal="true" aria-labelledby="dl-title">
      <h2 id="dl-title">ご利用の前に</h2>
      <ul>
        <li>運転中に画面を注視・操作しないでください（道路交通法で禁止されています）。操作は停車中に、または同乗者が行ってください。</li>
        <li>表示されるルートや案内は実際の交通規制と異なる場合があります。必ず実際の道路標識・規制に従ってください。</li>
        <li>本アプリは試験提供中です。利用によって生じた損害について責任を負いかねます。</li>
        <li>現在地はルート検索のためだけに経路検索サービスへ送信されます。住所・施設の検索では、近い結果を優先するために地図の中心のおおよその位置（約10km単位）を検索サービスへ送信します。どちらもサーバーに保存はしません。</li>
      </ul>
      <button class="btn primary" data-accept>${agreed ? '開始する' : '同意して開始'}</button>
    </div>`;
  document.body.append(el);
  el.querySelector<HTMLButtonElement>('[data-accept]')!.addEventListener('click', async () => {
    store.set(KEY, '1');
    el.remove();
    await onAccept();
  });
}
